import { useTheme } from 'styled-components';

/**
 * These strings will be used in Storybook and tests.
 */
export const previewTranslations = {
  addMore: {
    addMore: 'Add more',
  },
  breadcrumbs: {
    overflowButtonLabel: 'More',
  },
  datePicker: {
    calendarWeek: 'CW',
  },
  select: {
    clearInput: 'Clear input',
    create: (itemName: string) => `Create "${itemName}"`,
    creating: (itemName: string) => `Creating "${itemName}"...`,
    searchOrCreate: 'Search or create',
    noResults: 'No results',
  },
  fileUploader: {
    uploadFile: 'Upload file',
  },
  imageUploader: {
    tooLarge: (args: { maxValue: string }) => `Must be at most ${args.maxValue}`,
    removeImage: 'Remove image',
    uploadImage: 'Upload image',
    uploadedImage: 'Uploaded image',
  },
  lightbox: {
    back: 'Back',
    close: 'Close',
    download: 'Download',
    pageDown: 'Page down',
    pageUp: 'Page up',
    print: 'Print',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    imageCount: (c: { current: number; total: number }) => `Image ${c.current} / ${c.total}`,
    pageCount: (c: { current: number; total: number }) => `Page ${c.current} / ${c.total}`,
  },
  popover: {
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    outOf: (currentPosition: number, total: number) => `${currentPosition} of ${total}`,
  },
  searchInput: {
    clearButtonLabel: 'Clear input',
    search: 'Search',
  },
  table: {
    noResults: 'There are no results to be shown.',
  },
  tabs: {
    overflowButtonLabel: 'More',
  },
  common: {
    new: 'New',
  },
  subcontractorPremium: {
    premium: 'Premium',
  },
};

export type Translations = typeof previewTranslations;

// For now, we will use styled components' theme, which is how CosunoUiTheme
// functions
export const useTranslations = <T extends keyof Translations>(namespace: T): Translations[T] =>
  useTheme().translations[namespace];
